import AstroClientRouter from "../../../../contents/docs/integrate/_snippets/details/astro-clientrouter.mdx";
import * as React from 'react';
export default {
  AstroClientRouter,
  React
};